import { useId, useEffect, useState } from 'react';
import * as S from './AddNewAudience.styled';
import { useForm, Controller } from 'react-hook-form';
import { FileUploader, CustomInput, ModalFooter, Loader } from 'components';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { formDataFromObject, downloadFile } from 'utils';
import { useSelector } from 'react-redux';

const AddNewAudience = ({ handleCloseWindow, handleChangeTab }) => {
  const formId = useId();
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const [saveCustAudAction, result] = manageCampaignsAPI.useSaveCustomeAudienceMutation();
  let exampleFilePath = useSelector(
    (state) =>
      state.general.mainCampaignObject.campaignPageExtendedDetails
        .str_customAudienceFileExampleUrls,
  );

  const { android_url } = JSON.parse(exampleFilePath);

  const {
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm({
    mode: 'onChange',
  });

  const onSubmit = async (data) => {
    const { cust_aud_name, cust_aud_file } = data;
    const res = await saveCustAudAction(formDataFromObject({ cust_aud_name, cust_aud_file }));
    return res;
  };

  useEffect(() => {
    if (result.isSuccess) {
      handleChangeTab('existing_audience');
    }
  }, [result]);

  return (
    <>
      <S.Content>
        {result.isLoading && <Loader.Global />}
        <S.Form onSubmit={handleSubmit(onSubmit)} id={formId}>
          <S.Box>
            <S.Field>
              <S.Label htmlFor='cust_aud_name'>Audience name:</S.Label>
              <Controller
                defaultValue=''
                rules={{
                  required: 'This field is required',
                }}
                name='cust_aud_name'
                control={control}
                render={({ field: { onChange, value }, formState: { errors } }) => (
                  <CustomInput
                    name='cust_aud_name'
                    id='cust_aud_name'
                    value={value}
                    onChange={onChange}
                    containerStyle={{ height: '68px' }}
                    error={!!errors?.cust_aud_name?.message}
                    errorText={errors?.cust_aud_name?.message}
                  />
                )}
              />
            </S.Field>
          </S.Box>
          <S.Box>
            <S.Field>
              <S.Label>Upload file:</S.Label>
              <p>
                You can upload a CSV file with a list of advertising IDs you wish to target.
                <br /> We support device ids either with SHA2 256 hashing or without.
                <br />
                Maximum file size to upload is 60MB.{' '}
                <S.Uploader onClick={() => downloadFile(android_url)}>
                  Download an example
                </S.Uploader>
              </p>
            </S.Field>
          </S.Box>
          <S.Box>
            <Controller
              defaultValue={null}
              rules={{
                required: 'This field is required',
              }}
              name='cust_aud_file'
              control={control}
              render={({ field: { onChange }, formState: { errors } }) => {
                return (
                  <FileUploader
                    availableTypes={['csv']}
                    onChange={onChange}
                    error={!!errors?.cust_aud_file?.message}
                    errorText={errors?.cust_aud_file?.message}
                    setIsSaveDisabled={setIsSaveDisabled}
                  />
                );
              }}
            />
          </S.Box>
        </S.Form>
      </S.Content>
      <ModalFooter
        form={formId}
        saveButtonType='submit'
        saveButtonText='Save'
        saveButtonOnClick={handleSubmit}
        close={handleCloseWindow}
        saveButtonDisabled={!isDirty || result.isLoading || isSaveDisabled}
      />
    </>
  );
};

export default AddNewAudience;
